<template>
  <nav class="bottom-nav">
    <div class="nav-inner">
      <button class="nav-btn" @click="goBack" title="返回">
        <i class="fas fa-chevron-left"></i>
      </button>
      <button class="nav-btn" @click="goForward" title="前进">
        <i class="fas fa-chevron-right"></i>
      </button>
      <button class="nav-btn nav-btn--home" @click="goHome" title="首页">
        <i class="fas fa-home"></i>
      </button>
      <button class="nav-btn" @click="goSearch" title="搜索">
        <i class="fas fa-search"></i>
      </button>
      <button class="nav-btn nav-btn--heart" @click="donate" title="奉献">
        <i class="fas fa-heart"></i>
      </button>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'AppNav',
  data: () => ({
    showShare: false
  }),
  watch: {
    '$route' (to, from) {
      this.handleRouteChange(to, from);
    }
  },
  methods: {
    goBack() {
      window.history.back();
    },
    goForward() {
      window.history.forward();
    },
    goHome() {
      this.$router.push('/');
    },
    goSearch() {
      this.$router.push('/search');
    },
    handleButtonClick() {
      window.location.href = 'https://qr.alipay.com/fkx123198b5yoxszv9ife12';
    },
    donate() {
      if (window.flutter_inappwebview) {
        window.flutter_inappwebview.callHandler('donate', 'Hello from Vue.js!')
      }
    },
    share() {
      var videoUrl = decodeURIComponent(this.$store.state.videoUrl);
      const pathArray = videoUrl.split('/');
      const fileName = pathArray[pathArray.length - 1];
      var url = videoUrl.replace(this.$apiHost, '');
      var shareUrl = this.$shareHtml + "?file=" + url;
      if (navigator.share) {
        navigator.share({
          title: fileName,
          url: shareUrl
        }).then(() => {
          console.log('Sharing success');
        }).catch((error) => {
          console.error('Sharing failed:', error);
        });
      }
    },
    handleRouteChange(to, from) {
      console.log('Route changed:', to.path, from.path);
      this.showShare = to.path.includes('video_player');
    },
    addToFavorites() {
      console.log('Added to favorites');
    }
  }
};
</script>

<style scoped>
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  border-top: 0.5px solid rgba(0, 0, 0, 0.08);
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

.nav-inner {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: var(--nav-height, 56px);
  max-width: 480px;
  margin: 0 auto;
  padding: 0 8px;
}

.nav-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: none;
  background: transparent;
  border-radius: 12px;
  cursor: pointer;
  color: var(--text-secondary, #6e6e73);
  transition: all 0.2s ease;
  -webkit-tap-highlight-color: transparent;
}

.nav-btn i {
  font-size: 18px;
  transition: transform 0.2s ease;
}

.nav-btn:active {
  transform: scale(0.88);
  background: rgba(0, 0, 0, 0.04);
}

.nav-btn:active i {
  transform: scale(0.92);
}

.nav-btn--home {
  color: var(--primary, #3b82f6);
}

.nav-btn--home i {
  font-size: 20px;
}

.nav-btn--heart {
  color: #ff6b6b;
}

@media (max-width: 480px) {
  .nav-inner {
    padding: 0 4px;
  }
  
  .nav-btn {
    width: 40px;
    height: 40px;
  }
  
  .nav-btn i {
    font-size: 17px;
  }
}
</style>